import { HomeIndex } from "./home/index";
import { UserHome } from "./user/home";
import { AdminUsers } from "./admin/users";
import { Dashboard } from "./user/dashboard";
import { Logs } from "./user/logs";
import { annotateDebugComponents } from "../utils/dev_corner";

export const AppRoutes = annotateDebugComponents([
  // public
  ["", HomeIndex, "Home"],
  // user
  ["/user", Dashboard, "Dashboard"],
  ["/user/dashboard", Dashboard, "Dashboard"],
  ["/user/logs", Logs, "Logs"],
  // admin
  ["/admin", AdminUsers, "Admin"],
]);
